import { MarketplaceConsoleAppDistributionsGroupByKey } from '@atlassian/mpac-types/client-graphql-schema-types';
const getGroupByKeyField = groupedBy => {
  switch (groupedBy) {
    case MarketplaceConsoleAppDistributionsGroupByKey.AppVersion:
      return 'appVersion';
    case MarketplaceConsoleAppDistributionsGroupByKey.ParentMajorVersion:
      return 'parentSoftwareMajorVersions';
    case MarketplaceConsoleAppDistributionsGroupByKey.ParentMinorVersion:
      return 'parentSoftwareMinorVersions';
    case MarketplaceConsoleAppDistributionsGroupByKey.ParentAllVersions:
      return 'parentSoftwareVersion';
    default:
      return null;
  }
};
const getGroupByKeyValueFromResponse = (record, groupedBy) => {
  const groupByKeyField = getGroupByKeyField(groupedBy);
  return groupByKeyField ? record[groupByKeyField] : MarketplaceConsoleAppDistributionsGroupByKey.None;
};
const makeAppDistributionsCountResponse = (record, groupedBy) => ({
  __typename: 'MarketplaceConsoleAppDistributionCountResponse',
  groupByKey: getGroupByKeyValueFromResponse(record, groupedBy),
  count: record.installCounts
});
const makeAppDistributionsResponse = (record, groupedBy) => ({
  __typename: 'MarketplaceConsoleAppDistributionsResponse',
  date: record.date,
  groupedBy,
  installs: [makeAppDistributionsCountResponse(record, groupedBy)]
});
export const transposeDistributionsData = (DistributionsData, groupedBy) => {
  const groupedByDate = {};
  DistributionsData.records.forEach(record => {
    const groupByKeyValueFromResponse = getGroupByKeyValueFromResponse(record, groupedBy);
    // Consider the record only if required group by key's value is present
    if (groupByKeyValueFromResponse) {
      if (!groupedByDate[record.date]) {
        groupedByDate[record.date] = makeAppDistributionsResponse(record, groupedBy);
      } else {
        // Checks if the group by key already exists in the current date
        const installsCountWithGroupByKey = groupedByDate[record.date].installs.find(entry => entry.groupByKey === groupByKeyValueFromResponse);
        if (installsCountWithGroupByKey) {
          installsCountWithGroupByKey.count += record.installCounts;
        } else {
          groupedByDate[record.date].installs.push(makeAppDistributionsCountResponse(record, groupedBy));
        }
      }
    }
  });
  return Object.values(groupedByDate);
};